import { AutoComplete, DatePicker, Form, Input, Select } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_id, select_search } from "../../../../Controllers/Global";
import dayjs from "dayjs";
import moment from "moment";
import taxes from "../../../taxes.json";
import payment_types from "../../../payment_types.json";
import Error from "../../../../Componets/Error";
import Modalcomponent from "../../../../Componets/Modal";
import { get_inventory } from "../../../../Controllers/Inventory/Batch";
import { get_tax } from "../../../../Controllers/Tax/Tax";
import { useParams } from "react-router-dom";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import { get_inventories_by_product } from "../../../../Controllers/Purchases/MaterialIssue";
import UserCurrency from "../../../../Componets/UserCurrency";

const MaterialIssuetable = React.forwardRef((props, focus) => {
  const { details, setDetails, totals, setTotals, requestData } = props;
  const { id } = useParams();

  focus.current[`delivery_date`] = createRef();
  focus.current[`payment_types`] = createRef();

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [selectedModalData, setSelectedModalData] = useState();

  const recalculateAllTotals = (data) => {
    const subtotal =
      data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total || 0),
        0,
      ) -
      data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.tax_amount || 0),
        0,
      );

    const taxamount = data?.reduce(
      (acc, currentValue) =>
        parseFloat(acc) + parseFloat(currentValue?.tax_amount || 0),
      0,
    );

    const grandtotal = data?.reduce(
      (acc, currentValue) =>
        parseFloat(acc) + parseFloat(currentValue?.total || 0),
      0,
    );

    setTotals((prev) => ({
      ...prev,
      subtotal: subtotal || 0,
      taxamount: taxamount || 0,
      total: grandtotal || 0,
    }));
  };

  const handleSearch = async (e, index) => {
    let data = [...details];

    const select = {
      api: "get-all-inventories",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({
          value: value?._id,
          label: (
            <div>
              <div>{value?.product?.name}</div>
              <div>
                <span>
                  <UserCurrency />{" "}
                  {value?.purchase_price?.toFixed(3) || "0.000"}
                </span>
                {` (#BATCH-${value?.number})`}
                {value?.stock > 0
                  ? ` | Stock: ${value?.stock}`
                  : ` | Out of Stock`}
              </div>
              {value?.expiry_date ? (
                <div>EXPIRY : {formatDateDDMMYYYY(value?.expiry_date)}</div>
              ) : (
                ""
              )}
            </div>
          ),
        });
      });

      data[index].options = options;
      setDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleModal = (modaldata) => {
    let data = [...details];
    let inventory = selectedModalData;
    let index = selectedModalData?.index;

    let inventory_description = null;
    let inventory_name = "";
    let inventory_batch = "";
    let inventory_expiry_date = "";
    let inventory_price_per_unit = "";
    let inventory_unit = "";
    let inventory_unit_name = "";
    let inventory_purchase_price = 0;
    let inventory_stock = 0;
    let inventory_tax = 0;
    let inventory_conversion = 0;
    let inventory_unit_details = [];

    let description_ids = [];

    data?.map((v, i) => {
      description_ids?.push(v?.unit);
    });

    if (!description_ids?.includes(modaldata)) {
      if (inventory?.data?._id == modaldata) {
        inventory_description = inventory?.data?._id;
        inventory_name = inventory?.data?.product?.name;
        inventory_batch = inventory?.data?.number;
        inventory_expiry_date = inventory?.data?.expiry_date;
        inventory_price_per_unit = inventory?.data?.price_per_unit;
        inventory_unit = modaldata;
        inventory_unit_name = inventory?.data?.product?.unit?.name;
        inventory_purchase_price = inventory?.data?.purchase_price;
        inventory_stock = inventory?.data?.stock;
        inventory_tax = inventory?.data?.tax;

        if (inventory?.data?.inventory_unit_details?.length > 0) {
          inventory?.data?.inventory_unit_details?.map((value, index) => {
            inventory_unit_details?.push({
              ...value,
              name: value?.name,
              purchase_price: value?.purchase_price,
              price_per_unit: value?.price_per_unit,
              purchase_price: value?.purchase_price,
              stock: value?.stock,
              unit_quantity: 0,
              unit_delivered: 0,
            });
          });
        }
      } else {
        let selected_unit = "";
        let unit_ids = [];

        if (inventory?.data?.inventory_unit_details?.length > 0) {
          inventory?.data?.inventory_unit_details?.map((value, index) => {
            unit_ids?.push(value?._id);
          });
        }

        if (unit_ids?.includes(modaldata)) {
          selected_unit =
            inventory?.data?.inventory_unit_details?.[
              unit_ids?.indexOf(modaldata)
            ];
        }

        inventory_description = inventory?.data?._id;
        inventory_name = inventory?.data?.product?.name;
        inventory_batch = inventory?.data?.number;
        inventory_expiry_date = inventory?.data?.expiry_date;
        inventory_unit = modaldata;
        inventory_unit_name = selected_unit?.name;
        inventory_purchase_price = selected_unit?.purchase_price;
        inventory_stock = selected_unit?.stock;
        inventory_tax = inventory?.data?.tax;
        inventory_conversion = selected_unit?.conversion;
      }

      data[index].description = inventory_description;
      data[index].name = inventory_name;
      data[index].batch = inventory_batch;
      data[index].expiry_date = inventory_expiry_date;
      data[index].unit = inventory_unit;
      data[index].unit_name = inventory_unit_name;
      data[index].quantity = "";
      data[index].requested_quantity = data[index]?.requested_quantity || 0;
      data[index].issued_quantity = "";
      data[index].purchase_price = inventory_purchase_price;
      data[index].stock = inventory_stock;
      data[index].tax = inventory_tax ? inventory_tax : null;
      data[index].conversion = inventory_conversion;
      data[index].unit_details_options = inventory_unit_details;
      data[index].inventory_source = inventory_description;

      focus.current[`issued_quantity${index}`].current.focus();

      setDetails(data);
      setModalData();
      setSelectedModalData();
    } else {
      let selected_index = description_ids?.indexOf(inventory?.data?._id);

      if (
        parseFloat(data[selected_index].issued_quantity || 0) <
        parseFloat(data[selected_index].stock || 0)
      ) {
        let quantity = data[selected_index].issued_quantity
          ? data[selected_index].issued_quantity
          : 0;
        let requestedQty = data[selected_index].requested_quantity || 0;

        if (
          !data[selected_index].is_sub_row &&
          parseFloat(quantity) + parseFloat(1) > parseFloat(requestedQty)
        ) {
          toast?.error(`Cannot exceed requested quantity (${requestedQty})`);
          return;
        }

        if (data[selected_index].is_sub_row) {
          const mainRowIndex = data.findIndex(
            (item, idx) =>
              idx !== selected_index &&
              item.name === data[selected_index].name &&
              item.requested_quantity > 0 &&
              !item.is_sub_row,
          );

          if (mainRowIndex !== -1) {
            let totalIssuedForProduct = 0;
            data.forEach((item, idx) => {
              if (
                idx !== selected_index &&
                item.name === data[selected_index].name
              ) {
                totalIssuedForProduct += parseFloat(item.issued_quantity || 0);
              }
            });

            const newTotal = totalIssuedForProduct + parseFloat(quantity) + 1;
            const requestedQtyMain = parseFloat(
              data[mainRowIndex]?.requested_quantity || 0,
            );

            if (newTotal > requestedQtyMain) {
              toast?.error(
                `Total issued quantity (${newTotal}) cannot exceed requested quantity (${requestedQtyMain})`,
              );
              return;
            }
          }
        }

        if (
          data?.[selected_index]?.conversion > 0 &&
          data?.[selected_index]?.issued_quantity + parseFloat(1) >=
            data?.[selected_index]?.conversion
        ) {
          toast?.error(
            `Quantity exceeding ${data?.[selected_index]?.conversion}`,
          );
        } else {
          data[selected_index].issued_quantity =
            parseFloat(quantity) + parseFloat(1);
          data[selected_index].quantity = parseFloat(quantity) + parseFloat(1);
          recalculateAllTotals(data);
        }

        setDetails(data);
        setModalData();
        setSelectedModalData();
      } else {
        toast?.error(`Stock only ${data[selected_index].stock}`);
      }
    }
  };

  const handleDescription = async (e, index) => {
    let data = [...details];

    if (e) {
      let params = {
        id: e,
      };
      const inventory = await get_inventory(params);

      if (inventory?.status) {
        let taxDetails = null;
        if (inventory?.data?.tax) {
          const data = {
            id: inventory?.data?.tax,
          };

          const taxResponse = await get_tax(data);

          if (taxResponse?.status) {
            taxDetails = taxResponse.data;
          }
        }
        if (
          inventory?.data?.expiry_date &&
          new Date(new Date(inventory?.data?.expiry_date).getTime()) <
            new Date()
        ) {
          toast?.error(
            `Inventory expired on ${formatDateDDMMYYYY(
              inventory?.data?.expiry_date,
            )}`,
          );
        } else {
          if (inventory?.data?.inventory_unit_details?.length > 0) {
            setOpen(true);

            let modaldata = [
              {
                ...inventory?.data,
                name: inventory?.data?.product?.unit?.name,
              },
            ];

            inventory?.data?.inventory_unit_details?.map((v, i) => {
              modaldata?.push(v);
            });

            setModalData(modaldata);
            setSelectedModalData({ ...inventory, index: index });
          } else {
            let description_ids = [];

            data?.map((v, i) => {
              description_ids?.push(v?.description);
            });

            if (!description_ids?.includes(e)) {
              let inventory_description = inventory?.data?._id;
              let inventory_name = inventory?.data?.product?.name;
              let inventory_batch = inventory?.data?.number;
              let inventory_expiry_date = inventory?.data?.expiry_date;
              let inventory_unit = inventory?.data?._id;
              let inventory_unit_name = inventory?.data?.product?.unit?.name;
              let inventory_purchase_price = inventory?.data?.purchase_price;
              let inventory_stock = inventory?.data?.stock;
              let inventory_tax = inventory?.data?.tax;
              let inventory_tax_rate = taxDetails?.rate || 0;
              let inventory_tax_details = taxDetails;

              let inventory_unit_details = [];
              if (inventory?.data?.inventory_unit_details?.length > 0) {
                inventory?.data?.inventory_unit_details?.map((value, index) => {
                  inventory_unit_details?.push({
                    ...value,
                    name: value?.name?.name,
                    price_per_unit: 0,
                    purchase_price: "",
                    unit_quantity: 0,
                    unit_delivered: 0,
                  });
                });
              }

              data[index].description = inventory_description;
              data[index].name = inventory_name;
              data[index].batch = inventory_batch;
              data[index].expiry_date = inventory_expiry_date;
              data[index].unit = inventory_unit;
              data[index].unit_name = inventory_unit_name;
              data[index].purchase_price = inventory_purchase_price;
              data[index].stock = inventory_stock;
              data[index].tax = inventory_tax ? inventory_tax : null;
              data[index].tax_rate = inventory_tax_rate;
              data[index].tax_details = inventory_tax_details;
              data[index].quantity = "";
              data[index].requested_quantity =
                data[index]?.requested_quantity || 0;
              data[index].issued_quantity = "";
              data[index].unit_details_options = inventory_unit_details;
              data[index].inventory_source = inventory_description;
              setDetails(data);

              focus.current[`issued_quantity${index}`].current.focus();
            } else {
              let selected_index = description_ids?.indexOf(e);

              if (
                parseFloat(data[selected_index].issued_quantity || 0) <
                parseFloat(data[selected_index].stock || 0)
              ) {
                let quantity = data[selected_index].issued_quantity
                  ? data[selected_index].issued_quantity
                  : 0;
                let delivered = data[selected_index].delivered
                  ? data[selected_index].delivered
                  : 0;
                let requestedQty = data[selected_index].requested_quantity || 0;

                if (
                  !data[selected_index].is_sub_row &&
                  parseFloat(quantity) + parseFloat(1) >
                    parseFloat(requestedQty)
                ) {
                  toast?.error(
                    `Cannot exceed requested quantity (${requestedQty})`,
                  );
                } else {
                  data[selected_index].issued_quantity =
                    parseFloat(quantity) + parseFloat(1);
                  data[selected_index].quantity =
                    parseFloat(quantity) + parseFloat(1);
                  data[selected_index].delivered =
                    parseFloat(delivered) + parseFloat(1);
                  recalculateAllTotals(data);
                }

                setDetails(data);
              } else {
                toast?.error(`Stock only ${data[selected_index].stock}`);
              }
            }
          }
        }
      } else {
        toast?.error("Inventory not found");
      }
    } else {
      data[index].id = "";
      data[index].description = null;
      data[index].name = "";
      data[index].batch = "";
      data[index].expiry_date = "";
      data[index].unit = "";
      data[index].unit_name = "";
      data[index].unit_details_options = null;
      data[index].quantity = "";
      data[index].requested_quantity = data[index]?.requested_quantity || 0;
      data[index].issued_quantity = "";
      data[index].conversion = 0;
      data[index].purchase = "";
      data[index].purchase_price = "";
      data[index].purchase_options = null;
      data[index].delivered = "";
      data[index].tax = null;
      data[index].tax_rate = 0;
      data[index].tax_details = null;
      data[index].free = "";
      data[index].barcode = "";
      data[index].price_per_unit = "";
      data[index].purchase_price = "";
      data[index].expiry_date = "";
      data[index].tax_amount = "0.000";
      data[index].total = 0;
      data[index].inventory_source = null;
      setDetails(data);
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key && e ? e : !key && e?.target?.value ? e?.target?.value : "";

    if (value >= 0) {
      let data = [...details];

      let data_purchase_price = data[index]?.purchase_price
        ? data[index]?.purchase_price
        : 0;
      let data_quantity = data[index]?.issued_quantity
        ? data[index]?.issued_quantity
        : 0;
      let data_free = data[index]?.free ? data[index]?.free : 0;
      let data_tax_rate = data[index]?.tax_rate
        ? data[index]?.tax_rate
        : data[index].tax_details?.rate
          ? data[index].tax_details?.rate
          : 0;
      let data_conversion = data[index].conversion ? data[index].conversion : 0;
      let data_requested_quantity = data[index]?.requested_quantity
        ? parseFloat(data[index]?.requested_quantity)
        : 0;
      let is_sub_row = data[index]?.is_sub_row || false;

      let purchase_price =
        name === "purchase_price" ? value : data_purchase_price;
      let quantity = name === "issued_quantity" ? value : data_quantity;
      let free = name === "free" ? value : data_free;
      let tax = name === "tax" ? value : data_tax_rate;

      if (name === "issued_quantity" && !is_sub_row) {
        if (parseFloat(value) > data_requested_quantity) {
          toast?.error(
            `Issued quantity cannot exceed requested quantity (${data_requested_quantity})`,
          );
          return;
        }
      }

      if (name === "issued_quantity" && is_sub_row) {
        const mainRowIndex = data.findIndex(
          (item, idx) =>
            idx !== index &&
            item.name === data[index].name &&
            item.requested_quantity > 0 &&
            !item.is_sub_row,
        );

        if (mainRowIndex !== -1) {
          let totalIssuedForProduct = 0;
          data.forEach((item, idx) => {
            if (idx !== index && item.name === data[index].name) {
              totalIssuedForProduct += parseFloat(item.issued_quantity || 0);
            }
          });

          const newTotal = totalIssuedForProduct + parseFloat(value);
          const requestedQty = parseFloat(
            data[mainRowIndex]?.requested_quantity || 0,
          );

          if (newTotal > requestedQty) {
            toast?.error(
              `Total issued quantity (${newTotal}) cannot exceed requested quantity (${requestedQty})`,
            );
            return;
          }
        }
      }

      let tax_amount = data_tax_rate
        ? parseFloat(purchase_price) *
          parseFloat(quantity ? quantity : 0) *
          (parseFloat(data_tax_rate) / 100)
        : 0;

      let total =
        parseFloat(purchase_price) * parseFloat(quantity ? quantity : 0) +
        parseFloat(tax_amount);

      let price_per_unit =
        parseFloat(total ? total : 0) /
        (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

      let unit_details_options = [];
      if (data?.[index]?.unit_details_options?.length > 0) {
        data?.[index]?.unit_details_options?.map((v, i) => {
          let total_quantity =
            parseFloat(quantity || 0) + parseFloat(free || 0);

          unit_details_options?.push({
            ...v,
            price_per_unit: price_per_unit
              ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
              : 0,
            unit_quantity: quantity
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
            unit_delivered: quantity
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
          });
        });
      }
      if (
        data_conversion > 0 &&
        parseFloat(quantity) + parseFloat(free) >
          data_conversion * data[index]?.stock
      ) {
        toast?.error(
          `Quantity exceeding ${data_conversion * data[index]?.stock}`,
        );
      } else {
        data[index][name] = value;
        data[index].quantity = value;
        data[index].unit_details_options = unit_details_options;
        data[index].delivered = value ? value : "";
        data[index].tax = tax ? tax : null;
        data[index].total = total ? total : 0;
        data[index].tax_amount = tax_amount ? tax_amount : "0.000";
        data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

        recalculateAllTotals(data);

        setDetails(data);
        setTotals({ ...totals });
      }
    }
  };

  const handleChange = (e, index, key) => {
    let data = [...details];
    data[index][e?.target?.name] = e?.target?.value;
    setDetails(data);
  };

  const handleRemove = (index) => {
    let data = [...details];
    data?.splice(index, 1);
    recalculateAllTotals(data);
    setDetails(data);
  };

  const handleAdd = () => {
    setDetails((prevDetails) => [
      ...prevDetails,
      {
        id: "",
        description: null,
        name: "",
        unit: "",
        unit_name: "",
        unit_details_options: null,
        quantity: "",
        requested_quantity: 0,
        issued_quantity: "",
        purchase: "",
        purchase_price: "",
        purchase_options: null,
        delivered: "",
        tax: 0,
        free: "",
        barcode: "",
        price_per_unit: "",
        purchase_price: "",
        expiry_date: "",
        tax_amount: "0.000",
        total: 0,
        inventory_source: null,
        is_sub_row: false,
      },
    ]);

    setTimeout(() => {
      focus.current[`description${details?.length}`].current.focus();
    }, 100);
  };

  return (
    <div>
      <Modalcomponent
        open={open}
        setOpen={setOpen}
        modalData={modalData}
        setModalData={setModalData}
        selectedModalData={selectedModalData}
        setSelectedModalData={setSelectedModalData}
        handleModal={handleModal}
      />
      <table className="w-full">
        <thead>
          <tr>
            <td className="border p-4 text-black">S.NO</td>
            <td className="border p-4 text-black">DESCRIPTION</td>
            <td className="border p-4 text-black">UNIT</td>
            <td className="border p-4 text-black">REQ.QTY</td>
            <td className="border p-4 text-black">ISSUED.QTY</td>
            <td className="border p-4 text-black">PRICE</td>
            <td className="border p-4 text-black">TAX</td>
            <td className="border p-4 text-black">TOTAL</td>
            {id ? <></> : <td className="border p-4 text-black">DELETE</td>}
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            focus.current[`description${index}`] = createRef();
            focus.current[`issued_quantity${index}`] = createRef();
            return (
              <React.Fragment key={index}>
                <tr className={value?.is_sub_row ? "bg-gray-50" : ""}>
                  <td className="border p-4 text-center text-gray-700">
                    {index + 1}
                    {value?.is_sub_row && (
                      <span className="text-xs text-gray-400 block">(sub)</span>
                    )}
                  </td>
                  <td className="border p-4">
                    {value?.description ? (
                      <div className="w-[300px]">
                        <div className="text-black">{value?.name}</div>
                        <div className="text-xs">{`#BATCH-${value?.batch}`}</div>
                        {/*   {value?.inventory_source && (
                          <div className="text-xs text-blue-600">
                            Source: {value?.inventory_source}
                          </div>
                        )} */}
                        <div className="text-xs">
                          {value?.expiry_date
                            ? `Expiry (${formatDateDDMMYYYY(value?.expiry_date)})`
                            : ""}
                        </div>
                        <div className="text-xs text-green-600">
                          Available Stock: {value?.stock || 0}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Select
                          className="w-[300px] text-regular"
                          name="description"
                          ref={focus.current[`description${index}`]}
                          placeholder="Description"
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          value={value?.description}
                          options={value?.options}
                          onSearch={(e) => handleSearch(e, index)}
                          onFocus={(e) => handleSearch("", index)}
                          onClick={(e) => handleSearch("", index)}
                          onChange={(e) => handleDescription(e, index)}
                          autoComplete="off"
                        />
                      </div>
                    )}
                    <Error id={`description${index}`} />
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.unit_name}</div>
                  </td>
                  <td className="border p-4 text-center">
                    <div className="font-medium">
                      {value?.requested_quantity || 0}
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    <div className="flex flex-col items-start">
                      <Input
                        type="number"
                        className="w-full text-regular"
                        name="issued_quantity"
                        ref={focus.current[`issued_quantity${index}`]}
                        placeholder="Issued Quantity"
                        value={value?.issued_quantity}
                        onChange={(e) => handleTotal(e, index)}
                        autoComplete="off"
                        max={
                          value?.is_sub_row
                            ? undefined
                            : value?.requested_quantity || 0
                        }
                      />
                      <div>
                        <Error id={`issued_quantity${index}`} />
                      </div>
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    <div>
                      <AutoComplete
                        className="w-[120px] text-regular"
                        name="purchase_price"
                        ref={focus.current[`purchase_price${index}`]}
                        placeholder="Price"
                        allowClear={true}
                        showSearch={true}
                        filterOption={false}
                        options={value?.purchase_options}
                        value={value?.purchase_price}
                        onChange={(e) =>
                          handleTotal(e, index, "purchase_price")
                        }
                        autoComplete="off"
                      />
                      <Error
                        className="pt-0.5 text-xs text-red-500 text-left"
                        id={`purchase_price${index}`}
                      />
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    <div>
                      {value?.tax_details
                        ? `${value?.tax_details?.rate}%`
                        : value?.tax
                          ? `${value?.tax}%`
                          : "0%"}
                    </div>
                    <div>
                      {value?.tax_amount
                        ? parseFloat(value?.tax_amount)?.toFixed(3)
                        : "0.000"}
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    {value?.total
                      ? parseFloat?.(value?.total)?.toFixed(3)
                      : "0.000"}
                  </td>
                  {id ? (
                    <></>
                  ) : (
                    <td className="border p-4 text-center">
                      <button
                        type="button"
                        className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                        onClick={() => handleRemove(index)}
                      >
                        <DeleteOutlined />
                      </button>
                    </td>
                  )}
                </tr>
                <tr>
                  <td className="border border-gray-200 border-b-gray-400 p-4 text-center"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  {id ? (
                    <></>
                  ) : (
                    <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  )}
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">SUBTOTAL</td>
            <td className="border p-4" colSpan={2}>
              {totals?.subtotal > 0 ? totals?.subtotal?.toFixed(3) : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-gray-700">TAX</td>
            <td className="border p-4" colSpan={2}>
              {totals?.taxamount > 0 ? totals?.taxamount?.toFixed(3) : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={6}></td>
            <td className="border p-4 text-black text-medium">TOTAL</td>
            <td className="border p-4 text-black text-medium" colSpan={2}>
              {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

export default MaterialIssuetable;
